'use strict';

module.exports = {
  deepCompare: require('./deepCompare'),
  deepCopy: require('./deepCopy'),
  deepEqual: require('./deepEqual'),
  deepMerge: require('./deepMerge'),
  getIn: require('./getIn'),
  slice: require('./slice'),
  updateIn: require('./updateIn')
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/misc/index.js
// module id = 2191
// module chunks = 37